import Spinner from 'components/ui/Spinner';
import StepNav from 'components/ui/StepNav';
import StepTitle from 'components/ui/StepTitle';
import { useEffect, useMemo, useState } from 'react';
import { getEvaluatedRealizations, getEvaluationRealizations, getEvaluationVp, newEvaluateRealization } from 'services/evaluation.service';
import { categories } from 'types/realization';

import { RealizationEvItem } from 'types/realization';
import { useModal } from 'context/ModalContext/Modal.context';
import ModalWarning from 'components/ui/ModalWarning';
import CardEvaluation from 'components/ui/CardEvaluation';
import NavButton from 'components/ui/Button/NavButton';
import { useAuth } from 'context/AuthContext';
import { clearRegistrationUser } from 'utils/fns';
import Filter from 'components/ui/Filter';
import { useLocation, useNavigate } from 'react-router';
import Realizations from 'pages/Realizations';
import { NoEvaluation } from '../NoEvaluation';
import { getCategories } from 'services/realization.service';
import { StageIds } from 'utils/constants';
import NavTab, { TabItem } from 'components/ui/NavTab';
import Pagination from 'components/ui/Pagination';

const evaluationName: Record<string, string> = {
    relevant: 'Relevante',
    very: 'Muito Relevante',
    extremaly: 'Extremamente Relevante'
};

const Vote = () => {
    const { showModal, closeModal } = useModal();
    const { user, currentStep, isBossUser } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [loadingRealizations, setLoadingRealizations] = useState(false);
    const [categories, setCategories] = useState<categories[]>([]);
    const [realizations, setRealizations] = useState<RealizationEvItem[]>([]);
    const [filter, setFilter] = useState<{
        category?: string;
        searchTerm?: string;
    }>({});

    const [filteredRealization, setFilteredRealization] = useState<RealizationEvItem[]>([]);

    const [selectedRealizations, setSelectedRealizations] = useState<RealizationEvItem[]>([]);

    const [selectedEvaluations, setSelectedEvaluations] = useState<{ realizationId: string; evaluation: string }[]>([]);
    const [tabItens, setTabItens] = useState<TabItem[]>([]);
    const [limit, setLimit] = useState(3);

    const [isSendEvaluate, setIsSendEvaluate] = useState(false);

    const isBossEvaluation = location.pathname.includes('evaluation-president');

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const [currentItens, setCurrentItens] = useState<RealizationEvItem[]>([]);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        fetchRealizations();
    }, [user]);

    const fetchRealizations = async () => {
        setLoadingRealizations(true);
        try {
            if (!!user) {
                const userLocationPrefix = user.detail.ro.slice(-2);
                let data;
                if (isBossEvaluation) {
                    let keyUser = !!user.detail.acessor ? user.detail.acessor.vp.matricula : user._id;
                    data = await getEvaluationVp(keyUser);
                } else {
                    data = await getEvaluationRealizations(userLocationPrefix, user.detail.mad, user, isBossEvaluation);
                }

                const items = data ? data.flatMap((item) => item.realizations) : [];

                if (isBossEvaluation) {
                    let newLimit = Math.ceil((40 / 100) * items.length);
                    setLimit(newLimit < 3 ? 3 : newLimit);
                }

                let newCategories = data
                    ? data.map((item) => {
                          return {
                              name: `${item.categoryName}(${item.realizations.length || 0})`,
                              _id: item.categoryName
                          };
                      })
                    : [];

                newCategories.unshift({
                    name: `Todas (${items.length})`,
                    _id: -1
                });
                setCategories(newCategories);

                setRealizations(items);
                setFilteredRealization(items);

                const indexOfLastItem = currentPage * perPage;
                const indexOfFirstItem = indexOfLastItem - perPage;
                const totalPages = Math.ceil(items.length / perPage);
                setTotalPages(totalPages);
            }
        } catch (e) {
        } finally {
            setLoadingRealizations(false);
        }
    };

    const handleSearch = (title?: string, category?: string) => {
        let filteredResult = realizations.filter((item) => {
            const matchesSearchTerm = title ? item.title.toLowerCase().includes(title.toLocaleLowerCase()) : true;
            const matchesCategory = category ? category === '-1' || item.categoria.toLowerCase() === category.toLocaleLowerCase() : true;
            return matchesSearchTerm && matchesCategory;
        });
        console.log(filteredResult.length);
        setFilteredRealization(filteredResult);
        setCurrentPage(1);
    };

    useEffect(() => {
        handleSearch(filter.searchTerm?.toLocaleLowerCase(), filter.category);
    }, [filter]);

    useEffect(() => {
        if (realizations.length > 0 && realizations.length <= limit) {
            setSelectedRealizations(realizations);
        }
    }, [realizations]);

    useEffect(() => {
        const indexOfLastItem = currentPage * perPage;
        const indexOfFirstItem = indexOfLastItem - perPage;
        setCurrentItens(filteredRealization.slice(indexOfFirstItem, indexOfLastItem));

        const totalPages = Math.ceil(filteredRealization.length / perPage);
        setTotalPages(totalPages);
    }, [currentPage, perPage, filteredRealization]);

    const onSelectRealization = (realization: RealizationEvItem) => {
        const uniqueCategories = Array.from(new Set(realizations.map((item) => item.categoria.trim().toLowerCase())));
        const uniqueCategoriesSelected = Array.from(new Set(selectedRealizations.map((item) => item.categoria.trim().toLowerCase())));

        if (selectedRealizations.length >= limit && !user?.detail.isBoss) {
            showModal(
                'limit-participants',
                <ModalWarning
                    title={`Você já indicou ${limit} realizações! `}
                    description="Para selecionar outra INICIATIVA, é necessário desmarcar uma realização selecionada anteriormente."
                    btnText="Continuar"
                    onClose={closeModal}
                />,
                'participant-limit'
            );
        } else if (
            ((uniqueCategories.length > 3 && uniqueCategoriesSelected.length < 3) || (uniqueCategories.length < 3 && uniqueCategories.length !== uniqueCategoriesSelected.length)) &&
            selectedRealizations.length >= limit - 1 &&
            selectedRealizations.find((item) => item.categoria === realization.categoria) && !user?.detail.isBoss
        ) {
            showModal(
                'evaluation-limit',
                <ModalWarning title={`Ops!`} description="Você deve selecionar pelo menos 3 realizações de diferentes categorias." btnText="Continuar" onClose={closeModal} />,
                'evaluation-limit'
            );
        } else {
            setSelectedRealizations((prev) => (prev.length < limit ? [...prev, realization] : prev));
            setFilteredRealization((prev) => prev.filter((item) => item._id !== realization._id));
        }
    };

    const onRemove = (realization: RealizationEvItem) => {
        console.log('onremove', realization);
        setSelectedRealizations((prev) => {
            const updated = prev.filter((item) => item._id !== realization._id);
            console.log('Updated selectedRealizations:', updated);
            return updated;
        });

        setSelectedEvaluations((prev) => {
            const updated = prev.filter((ev) => ev.realizationId !== realization._id);
            console.log('Updated selectedEvaluations:', updated);
            return updated;
        });

        setFilteredRealization((prev) => {
            const updated = [...prev.filter((item) => item._id !== realization._id), realization];
            console.log('Updated filteredRealization:', updated);
            return updated;
        });
    };

    const onEvaluation = (realization: RealizationEvItem, evaluation: string) => {
        if (!isBossEvaluation) {
            const alreadySelected = selectedEvaluations.find((ev) => ev.evaluation === evaluation);

            if (alreadySelected && alreadySelected.realizationId !== realization._id) {
                showModal(
                    'evaluation-limit',
                    <ModalWarning
                        title={`Já existe uma realização marcada como "${evaluationName[evaluation]}".`}
                        description="Cada nível de classificação pode ser usado apenas uma vez."
                        btnText="Continuar"
                        onClose={closeModal}
                    />,
                    'evaluation-limit'
                );
                return;
            }
        }

        setSelectedEvaluations((prev) => {
            const updated = [...prev.filter((ev) => ev.realizationId !== realization._id), { realizationId: realization._id, evaluation }];
            return updated;
        });
    };

    const confirmVote = () => {
        if (user?.detail?.acessor?.vp) {
            showModal(
                'confirm-vote',
                <ModalWarning
                    title="Simulação de voto"
                    description={`Você está simulando o voto no Prêmio BB. Mas seu voto não pode ser enviado!`}
                    btnText="Fechar"
                    hasBackButton={true}
                    onClose={closeModal}
                    onBackButton={closeModal}
                />,
                'confirm-vote'
            );
        } else {
            showModal(
                'confirm-vote',
                <ModalWarning
                    title="Confirmação de Voto"
                    description={`Você selecionou ${selectedRealizations.length} do total de ${limit} realizações que é possível votar. Confirma o envio do seu voto?`}
                    btnText="Enviar voto"
                    hasBackButton={true}
                    onClose={handlerEvaluate}
                    onBackButton={closeModal}
                />,
                'confirm-vote'
            );
        }
    };

    const handlerEvaluate = async () => {
        setIsSendEvaluate(true);
        try {
            if (!!user) {
                let check = await getEvaluatedRealizations(user);

                if (!!check && check.realizations.length > 0) {
                    showModal(
                        'evaluation-limit',
                        <ModalWarning title={`Ops!`} description="Você já votou uma vez!" btnText="Continuar" onClose={() => [closeModal, navigate('/evaluation')]} />,
                        'evaluation-limit'
                    );
                    return;
                }

                let currentPlayer = clearRegistrationUser(user?._id);

                let realizations = selectedRealizations.map((item) => ({
                    ...item,
                    evaluation: selectedEvaluations.find((selected) => selected.realizationId === item._id)?.evaluation
                }));
                const result = await newEvaluateRealization({
                    player: currentPlayer,
                    rawPlayer: user._id,
                    date: new Date(),
                    realizations: realizations,
                    step: isBossEvaluation ? 2 : undefined
                });
                navigate(user.detail.isBoss ? '/evaluation-president' : '/evaluation');
            }
        } catch (e) {
            console.log(e);
        } finally {
            setIsSendEvaluate(false);
        }
    };

    useEffect(() => {
        async function fetchCategories() {
            try {
                const categoriesData = await getCategories();
                const formattedCategories = categoriesData.map((category: any) => ({
                    _id: category._id,
                    name: `${category._id}`
                }));
                setCategories([{ _id: '-1', name: 'Todas as categorias' }, ...formattedCategories.filter((category: any) => category.name !== 'N/A' && category.name.trim() !== '')]);
            } catch (e) {
                console.log(e);
            }
        }
        fetchCategories();
    }, []);

    const isDisabled = useMemo(() => {
        if (isBossEvaluation) {
            const check = selectedRealizations.length < 3;
            if (selectedRealizations.length > 2) {
                const uniqueCategoriesSelected = Array.from(new Set(selectedRealizations.map((item) => item.categoria.trim().toLowerCase())));
                const uniqueCategories = Array.from(new Set(realizations.map((item) => item.categoria.trim().toLowerCase())));
                if (((uniqueCategories.length >= 3 && uniqueCategoriesSelected.length < 3) || (uniqueCategories.length < 3 && uniqueCategories.length !== uniqueCategoriesSelected.length)) && !user?.detail.isBoss) {
                    showModal(
                        'evaluation-limit',
                        <ModalWarning title={`Ops!`} description="Você deve selecionar pelo menos 3 realizações de diferentes categorias." btnText="Continuar" onClose={closeModal} />,
                        'evaluation-limit'
                    );
                }
                return (uniqueCategories.length >= 3 && uniqueCategoriesSelected.length < 3) || (uniqueCategories.length < 3 && uniqueCategories.length !== uniqueCategoriesSelected.length);
            }
            return check;
        } else {
            if (realizations.length < limit) {
                return selectedEvaluations.length < selectedRealizations.length;
            } else {
                return selectedRealizations.length < limit || selectedEvaluations.length < limit;
            }
        }
    }, [isBossEvaluation, selectedEvaluations, selectedRealizations, realizations, limit]);

    const stepDescription = () => {
        return `Abaixo estão as iniciativas da sua Vice-Presidência inscritas no Prêmio BB 2024. A partir dessa lista, vote em até 40% das realizações que mais representem as categorias do Prêmio BB 2024.
<br><br>
Lembrando que o Prêmio BB possui 5 categorias alinhadas à ECBB: <br>
1) ASG, 
2) Clientes, 
3) Financeira, 
4) Transformação Digital e Processos e 
5) Pessoas e Cultura. 
<br><br>
Caso as iniciativas abaixo tenham apenas 2 categorias diferentes, é obrigatório escolher ao menos 1 iniciativa em cada categoria. Caso as iniciativas abaixo tenham de 3 a 5 categorias diferentes, é obrigatório escolher ao menos 1 iniciativa para 3 categorias distintas.
<br><br>
Para auxiliar na sua escolha, sugerimos visualizar as informações, vídeo e ou arquivo disponível em cada iniciativa.`;
    };

    return (
        <>
            {loadingRealizations && (
                <div className="flex items-start justify-center w-full h-screen">
                    <div className="flex flex-col">
                        <Spinner />
                        <span className="text-center text-blue-bb">Carregando...</span>
                    </div>
                </div>
            )}
            {!loadingRealizations && (
                <>
                    {(!user?.detail.isBoss || !user?.detail?.acessor?.vp) && currentStep?._id !== StageIds.STAGE_DOIS_AVALIACAO ? (
                        <NoEvaluation />
                    ) : (
                        <>
                            <StepNav currentStep={isBossEvaluation ? 3 : 2} activeSubStep={1} />
                            <StepTitle title={isBossEvaluation ? 'Etapa 2 de avaliação' : 'Etapa 1 de avaliação'} description={stepDescription()} />

                            <div className="mx-4 mb-0 md:mb-16 md:mx-0">
                                <div className="flex flex-col items-center mb-12 md:flex-row md:justify-between">
                                    <h2 className="text-gray-bb-1 font-title text-xl md:text-[26px] mb-8 font-bold">
                                        Realizações selecionadas ({selectedRealizations.length}/{limit})
                                    </h2>
                                    <NavButton text={'Votar'} bgColor={'#FCFC30'} disabled={isBossEvaluation ? false : isDisabled} isLoading={isSendEvaluate} onClick={confirmVote} />
                                </div>

                                {selectedRealizations.length === 0 && <p>Você ainda não selecionou nenhuma realização.</p>}
                                {selectedRealizations.map((item: RealizationEvItem, index: number) => (
                                    <CardEvaluation
                                        data={item}
                                        key={item._id}
                                        qtdEvaluation={realizations.length}
                                        allowRemove={true}
                                        onSelect={(e) => {
                                            console.log('selected', e);
                                        }}
                                        selectedEvaluations={selectedEvaluations}
                                        onEvaluation={onEvaluation}
                                        onRemove={onRemove}
                                        showOptions={!isBossEvaluation}
                                    />
                                ))}
                            </div>
                            <div className="flex justify-center w-full my-4 md:justify-end md:my-0 ">
                                <NavButton text={'Votar'} bgColor={'#FCFC30'} disabled={isBossEvaluation ? false : isDisabled} isLoading={isSendEvaluate} onClick={confirmVote} />
                            </div>

                            {/* DESKTOP */}
                            {!(realizations.length <= limit) && (
                                <div>
                                    <h2 className="text-gray-bb-1 font-title text-xl md:text-[26px] mb-8 font-bold ml-4 md:ml-0">Lista de realizações ({realizations.length})</h2>
                                    <div className="flex items-end justify-end">
                                        <div className="w-full">
                                            <Filter
                                                categories={categories}
                                                enableCategoryFilter={true}
                                                onChange={(key, value) => {
                                                    setFilter((prev) => ({ ...filter, [key]: value }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {loadingRealizations ? (
                                <div className="flex items-start justify-center w-full h-screen">
                                    <div className="flex flex-col">
                                        <Spinner />
                                        <span className="text-center text-blue-bb">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {!(realizations.length <= limit) && (
                                        <div className="grid-cols-1 mx-4 md:grid md:mx-0 md:grid-cols-2 gap-7 content">
                                            {(isBossEvaluation ? currentItens : filteredRealization).map((item: RealizationEvItem, index: number) => (
                                                <CardEvaluation
                                                    qtdEvaluation={realizations.length}
                                                    data={item}
                                                    key={item._id}
                                                    onSelect={onSelectRealization}
                                                    onEvaluation={function (val?: RealizationEvItem): void {
                                                        throw new Error('Function not implemented.');
                                                    }}
                                                    onRemove={function (val?: RealizationEvItem): void {
                                                        throw new Error('Function not implemented.');
                                                    }}
                                                    showOptions={false}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </>
                            )}

                            <Pagination totalPages={totalPages} currentPage={currentPage} onPage={setCurrentPage} />
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default Vote;
